import { LegacyCoupon } from '@/types/legacyCoupon';

export enum ActionTypes {
  FETCH_ORDERS_START = 'orders/FETCH_ORDERS_START',
  FETCH_ORDERS_SUCCESS = 'orders/FETCH_ORDERS_SUCCESS',
  FETCH_ORDERS_FAIL = 'orders/FETCH_ORDERS_FAIL',
  CLEAR_ORDERS = 'orders/CLEAR_ORDERS',
  REMOVE_SELECTED_ORDER = 'orders/REMOVE_SELECTED_ORDER',
}

export interface State {
  isLoading: boolean;
  error: string;
  data?: LegacyCoupon[];
}
export interface FetchOrdersStartAction {
  type: ActionTypes.FETCH_ORDERS_START;
}
export interface FetchOrdersSuccessAction {
  type: ActionTypes.FETCH_ORDERS_SUCCESS;
  payload: LegacyCoupon[];
}
export interface FetchOrdersFailAction {
  type: ActionTypes.FETCH_ORDERS_FAIL;
  payload: string;
}

export interface ClearOrders {
  type: ActionTypes.CLEAR_ORDERS;
}

export interface RemoveSelectedOrder {
  type: ActionTypes.REMOVE_SELECTED_ORDER;
  payload: string;
}

export type ActionType =
  | FetchOrdersStartAction
  | FetchOrdersSuccessAction
  | FetchOrdersFailAction
  | ClearOrders
  | RemoveSelectedOrder;
